import React from 'react';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';

export default function HomePage() {
  return (
    <div className="page-shell min-h-screen pb-2">
      <Header />
      <Hero />
      <TrustBar />
      <Features />



      <Footer />
    </div>
  );
}
